import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ElementPortableText from 'src/components/ElementPortableText/ElementPortableText';

function SimpleHalfBlocks({ halfBlocks }) {
  return (
    <Container as="section" className="py-5">
      <Row>
        {halfBlocks.map((block, i) => (
          <Col xs={12} md={6} key={i}>
            <ElementPortableText content={block.description} />
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default SimpleHalfBlocks;
